import { HttpParams } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    FilterSearchingRestriccionProductosExViewModel,
    RestriccionProductosExItemResultsViewModel,
    RestriccionProductosExViewModel,
} from './restriccionproductoex.types';

@Injectable()
export class RestriccionProductosExService {
    restriccionProductosExEndpoint = this.baseUrl + 'api/mantenimiento/restriccionproductosex/';
    private lastSearch?: FilterSearchingRestriccionProductosExViewModel;

    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {}

    private convertModelToHttpParms(payload: FilterSearchingRestriccionProductosExViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingRestriccionProductosExViewModel;

        for (k in payload) {
            let v;
            let valor = payload[k];
            if (k == 'Activa' && valor == 0) {
                v = 0;
            } else {
                v = payload[k] || '';
            }

            params = params.append(k, v);
        }

        return params;
    }

    getRestriccionesProductosEx(payload: FilterSearchingRestriccionProductosExViewModel): Observable<RestriccionProductosExItemResultsViewModel> {
        this.lastSearch = payload; // Keep for future search
        const params = this.convertModelToHttpParms(payload);
        return this.getRestriccionesProductosExPagedByFilter(params);
    }

    private getRestriccionesProductosExPagedByFilter(params: HttpParams): Observable<RestriccionProductosExItemResultsViewModel> {
        return this.http.get<RestriccionProductosExItemResultsViewModel>(this.restriccionProductosExEndpoint + 'PagedByFilter/', { params: params });
    }

    getRestriccionProductosEx(idEspecie: number, idPaisDestino: number): Observable<RestriccionProductosExViewModel> {
        return this.http.get<RestriccionProductosExViewModel>(this.restriccionProductosExEndpoint + 'getbyid/' + idEspecie + '/' + idPaisDestino);
    }

    //saveRestriccionProductosEx(restriccion: RestriccionProductosExViewModel): Observable<any> {
    //    if (restriccion?.IdEspecie && restriccion?.IdPaisDestino) {
    //        // Validación no válida
    //        return this.edit(restriccion);
    //    }
    //    return this.create(restriccion);
    //}

    create(restriccion: RestriccionProductosExViewModel): Observable<any> {
        return this.http.post<RestriccionProductosExViewModel>(this.restriccionProductosExEndpoint, restriccion);
    }

    edit(restriccion: RestriccionProductosExViewModel): Observable<any> {
        return this.http.put<RestriccionProductosExViewModel>(this.restriccionProductosExEndpoint, restriccion);
    }

    delete(idEspecie: number, idPaisDestino: number): Observable<any> {
        return this.http.delete<RestriccionProductosExViewModel>(this.restriccionProductosExEndpoint + idEspecie + '/' + idPaisDestino);
    }

    getLastSearch(): FilterSearchingRestriccionProductosExViewModel | undefined {
        return this.lastSearch;
    }

    clearLastSearch(): void {
        this.lastSearch = undefined;
    }
}
